export default __webpack_public_path__ + "static/media/techsicoLogoVertical.b683227d.svg";